<div *ngIf="!loading">
  <br>
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="col-xs-12  animated fadeIn">
  <div class="box no-padding">
    <div class="box-header">
      <h3 class="box-title">Todas alterações solicitadas</h3>
    </div>

    <div class="box-body table-responsive no-padding">
      <table class="table table-hover">
        <tbody>

          <tr *ngIf="listVersoesPlano.length != 0">
            <th class="text-center">Versão</th>
            <th>Data da Solicitação</th>
            <th>Status</th>
            <th>Ação</th>
          </tr>
          <tr *ngFor="let item of listVersoesPlano; let iteration = index;">
            <td class="text-center"> <b>#{{  iteration+1 }}</b></td>
            <td>{{ item.dataSolicitacao | date: 'dd MMM. yyyy' }}</td>
            <td>  
              <span *ngIf="item.status == 'Aguardando_avaliacao'" class="badge bg-blue cursor">
                <b>{{ getDescricaoStatus(item.status) }} </b> 
              </span>
              <span *ngIf="item.status == 'Aceito'" class="badge bg-green cursor">
                <b>{{ getDescricaoStatus(item.status) }} </b> 
              </span>
              <span *ngIf="item.status == 'Recusado'" class="badge bg-red cursor">
                  <b>{{ getDescricaoStatus(item.status) }} </b> 
              </span>
            </td>
            <td>
              <!-- <span class="badge bg-blue cursor" pTooltip="Alterar" tooltipPosition="top"
                (click)="alteracaoSelecionada(item)">
                <i class="fa fa-edit"></i></span>
                <span class="badge bg-blue cursor" pTooltip="Avaliar" tooltipPosition="top"
                (click)="avaliarAlteracao(item)">
                <i class="fa fa-check"></i></span> -->
                <span *ngIf="item.status == 'Aguardando_avaliacao'" class="badge bg-blue cursor" pTooltip="Avaliar" tooltipPosition="top"
                (click)="avaliarAlteracaoOpen(item)" >
                <i class="fa fa-check"></i></span>
                <span *ngIf="item.status == 'Aceito' || item.status == 'Recusado'" class="badge bg-blue cursor" pTooltip="Visualizar parecer" tooltipPosition="top"
                (click)="visualizarParecerOpen(item)" >
                <i class="fa fa-eye"></i></span>
            </td>
          </tr>

          <div class="text-center" *ngIf="listVersoesPlano.length == 0">
            <hr>
            <h5><b>Nenhum registro encontrado</b></h5>
          </div>

        </tbody>
      </table>
    </div>

  </div>
</div>

<p-dialog [style]="{width: '800px'}" header="Avaliar justificativa"[(visible)]="openModalViewPDF" showEffect="fade" [modal]="true">
  <div class="col-sm-12 no-padding" style="display: flex; align-items: center;">
    <h4 class="col-sm-9 no-padding">
      <b>Justificativa</b>
    </h4>
    <div class="col-sm-3 no-padding" style="text-align: end;">
      <button (click)="mudarStatus('Aceito')" class="btn btn-success btn-sm" [disabled]="!parecerPreenchido()">Aceitar</button>
      <button (click)="mudarStatus('Recusado')" class="btn btn-danger btn-sm" [disabled]="!parecerPreenchido()">Recusar</button>
    </div>
  </div>
  <br>
  <br>
  <div class="col-sm-12" [innerHtml]="versaoPlano.justificativa"></div>
  <br>

  <div class="col-sm-12 no-padding">
    <div class="form-group">
      <label for="parecerAvaliacao"><span style="color:red;">*</span>Justificativa do aceite ou recusa</label>
      <textarea id="parecerAvaliacao" name="parecerAvaliacao" [(ngModel)]="versaoPlano.parecerAvaliacao" class="form-control" rows="3"
        placeholder="Informe a justificativa ..."></textarea>
    </div>
  </div>
  <br>
 
  <div class="myIframe" *ngIf="versaoPlano.hashFile" >
    <h4>
      <b>Arquivo</b>
    </h4>
    <br>
    <iframe [src]="urlDown | safe" frameborder='0'></iframe>
  </div>
</p-dialog>

<p-dialog [style]="{width: '700px'}" header="Visualizar parecer" [(visible)]="openModalViewParecer" showEffect="fade" [modal]="true">
  <div class="col-sm-12 no-padding">
    <h4> 
      <b>Justificativa da solicitação</b>
    </h4>
    <div [innerHtml]="versaoPlano.justificativa"></div>
  </div>
  <br>
  <div class="col-sm-12 no-padding">
    <div class="form-group">
      <label for="parecerAvaliacaoVisualizacao">Parecer do aceite ou recusa</label>
      <textarea id="parecerAvaliacaoVisualizacao" class="form-control" rows="4" [value]="parecerVisualizacao()" readonly></textarea>
    </div>
  </div>
</p-dialog>
